export default "__VITE_PUBLIC_ASSET__d9b7a7d9__"